var _g, _rect, _rect2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 474,
    height: 105,
    viewBox: "0 0 474 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2161_4254)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.5865 29.6047C28.5865 21.6586 15.6972 9.84568 6.57585 3.59247C5.22659 2.66748 5.93749 0 7.57337 0H42.0828C43.2085 0 43.9493 1.18009 43.4737 2.20043C37.5671 14.8718 28.5865 39.0433 28.5865 29.6047Z",
    fill: "#005993"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.4478,
    width: 442.552,
    height: 98.6823,
    rx: 7.59095,
    fill: "#005993"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 56.2935,
    y: 31.123,
    width: 378.029,
    height: 12.1455,
    rx: 6.07276,
    fill: "#004674"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 56.2935,
    y: 55.4141,
    width: 282.383,
    height: 12.1455,
    rx: 6.07276,
    fill: "#004674"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2161_4254",
    x: 2.83032,
    y: 0,
    width: 470.206,
    height: 104.755,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.03638
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.51819
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2161_4254"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2161_4254",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatEmpty);
export default __webpack_public_path__ + "static/media/chat-empty.2abbc080aed57beaebf6d71ca4dd4b41.svg";
export { ForwardRef as ReactComponent };